import { createGetAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { useGet: useGetRegionalTrialSlots } = createGetAPI({
  // studentServiceId rides in `query` (not a 4th arg): createGetAPI forwards only
  // 3 args to getURL and keys its cache on id + query, so it must vary per student.
  getURL: (timezone, query = {}, meta = {}) => {
    const { region, studentServiceId } = query;
    const { startHours } = meta;
    let url = `${BASE_URL}/teachers/regional-trial-slots/?timezone=${timezone}&opportunity_region=${region}&start_hours=${startHours}`;
    if (studentServiceId) {
      url += `&student_service_id=${studentServiceId}`;
    }
    return url;
  },
});

export { useGetRegionalTrialSlots };
